<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('loadingDate') }" class="colStyle">
      {{ items.loadingDate }}
    </div>
    <div v-bind:style="{ width: getWidth('loadingName') }" class="colStyle">
      {{ items.loadingName }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  methods: {
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj && obj.width ? obj.width : '100px'
    }
  }
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
</style>
